export const getLeadPopup = () => localStorage?.getItem('lead_popup');
export const setLeadPopup = (value) => localStorage?.setItem('lead_popup', value);
export const getLeadData = () => localStorage?.getItem('lead_data');
export const setLeadData = (value) => localStorage?.setItem('lead_data', value);
export const getLeadId = () => localStorage?.getItem('lead_id');
export const setLeadId = (value) => localStorage?.setItem('lead_id', value);
